module.exports = __webpack_public_path__ + "img/gandan.33ac6356.png";